const img = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const HERO_IMAGE = "/machines/baytas-hero.jpg";

export const MACHINES = [
  {
    slug: "kultuvator",
    name: "Kültüvatör",
    category: "Toprak İşleme",
    tagline: "Spiral ayaklı kültüvatör",
    short:
      "Spiral ayaklarıyla toprağı havalandıran, yabancı otları parçalayan ve tohum yatağı hazırlayan kültüvatör.",
    description:
      "Toprağı havalandırmak, yabancı otları parçalamak ve tohum yataklarını hazırlamak için kullanılan spiral ayakları sayesinde ekimden önce toprağa ferahlık sağlar.",
    image: "/machines/kultuvator-1.jpg",
    gallery: [
      "/machines/kultuvator-1.jpg",
      "/machines/kultuvator-2.jpg",
      "/machines/kultuvator-3.jpg",
    ],
    specTables: [
      {
        title: "Merdanesiz Model",
        columns: ["Ayak Sayısı", "İş Genişliği (cm)", "Yol Genişliği (cm)"],
        rows: [
          ["35 Ayak", "350", "250"],
          ["40 Ayak", "400", "250"],
          ["45 Ayak", "450", "250"],
          ["50 Ayak", "500", "250"],
          ["54 Ayak", "550", "250"],
          ["60 Ayak", "600", "250"],
          ["64 Ayak", "650", "250"],
        ],
      },
      {
        title: "Merdaneli Model",
        columns: ["Ayak Sayısı", "İş Genişliği (cm)", "Yol Genişliği (cm)", "Ağırlık (kg)"],
        rows: [
          ["35 Ayak", "350", "250", "990"],
          ["40 Ayak", "400", "250", "1100"],
          ["45 Ayak", "450", "250", "1210"],
          ["50 Ayak", "500", "250", "1320"],
          ["54 Ayak", "550", "250", "1600"],
          ["60 Ayak", "600", "250", "1750"],
          ["64 Ayak", "650", "250", "1900"],
        ],
      },
    ],
    seo: {
      title: "Kültüvatör | Baytaş Tarım",
      description:
        "Baytaş Tarım kültüvatörleri: spiral ayaklı, merdanesiz ve merdaneli toprak işleme makineleri. Detaylı bilgi için bize ulaşın.",
    },
  },
  {
    slug: "kaldirac",
    name: "Kaldıraç",
    category: "Yükleme",
    tagline: "Hidrolik kaldırma makinesi",
    short:
      "Tüm traktör ve gübre serpme makineleriyle çalışabilen, 1 ton kaldırma kapasiteli hidrolik kaldıraç.",
    description:
      "Tüm traktör ve gübre serpme makinalarıyla çalışabilir, 1 ton kaldırma kapasitesi vardır. Hidrolik sistem arızalarına karşı emniyet valfi mevcuttur. Bom makarası ile sorunsuz çalışır. Askıları sayesinde park pozisyonunda hortumlarının zarar görmesini engeller. Hızlı ve kolay bağlanır.",
    image: "/machines/kaldirac-1.png",
    gallery: [
      "/machines/kaldirac-1.png",
      "/machines/kaldirac-2.jpg",
      "/machines/kaldirac-sahadan-1.webp",
      "/machines/kaldirac-sahadan-2.webp",
    ],
    specGroups: [
      {
        title: "4500 mm",
        rows: [
          ["Maximum Taşıma Kapasitesi (kg)", "1000"],
          ["Minimum Taşıma Kapasitesi (kg)", "600"],
          ["Makine Ağırlığı (kg)", "305"],
        ],
      },
      {
        title: "5500 mm",
        rows: [
          ["Maximum Taşıma Kapasitesi (kg)", "1300"],
          ["Minimum Taşıma Kapasitesi (kg)", "900"],
          ["Makine Ağırlığı (kg)", "415"],
        ],
      },
    ],
    seo: {
      title: "Kaldıraç | Baytaş Tarım",
      description:
        "Baytaş Tarım kaldıraç: gübre serpme makineleri için 1 ton kaldırma kapasiteli hidrolik makine. Detaylı bilgi için bize ulaşın.",
    },
  },
  {
    slug: "cizel",
    name: "Çizel",
    category: "Derin Sürüm",
    tagline: "Chisel tipi derin sürüm makinesi",
    short:
      "Hasat sonrası pulluğa ihtiyaç duymadan toprağı işleyen, uzun bacaklı derin sürüm makinesi.",
    description:
      "Hasattan sonra pulluğa ihtiyaç duymadan toprağın işlenmesinde kullanılır. Uzun bacakları sayesinde pulluğun altında oluşan sert üst kabuğu parçalar. Pulluk işleminin yapılmadığı kuru yaz aylarında daha az kesekli toprak için kullanılır.",
    image: "/machines/cizel-1.jpg",
    gallery: [
      "/machines/cizel-1.jpg",
      "/machines/cizel-2.jpg",
      "/machines/cizel-3.jpg",
      "/machines/cizel-4.jpg",
      "/machines/cizel-5.jpg",
      "/machines/cizel-6.jpg",
      "/machines/cizel-7.jpg",
    ],
    specTables: [
      {
        title: "Merdanesiz Model",
        columns: ["Ayak Sayısı", "İş Genişliği (cm)", "Yol Genişliği (cm)", "Ağırlık (kg)"],
        rows: [
          ["5 Ayak", "140", "152", "400"],
          ["7 Ayak", "200", "215", "460"],
          ["9 Ayak", "270", "280", "560"],
          ["10 Ayak", "290", "304", "700"],
          ["11 Ayak", "290", "304", "740"],
          ["13 Ayak", "350", "370", "870"],
        ],
      },
      {
        title: "Merdaneli Model",
        columns: ["Ayak Sayısı", "İş Genişliği (cm)", "Yol Genişliği (cm)", "Ağırlık (kg)"],
        rows: [
          ["5 Ayak", "140", "152", "510"],
          ["7 Ayak", "200", "215", "610"],
          ["9 Ayak", "270", "280", "740"],
          ["10 Ayak", "290", "304", "880"],
          ["11 Ayak", "290", "304", "920"],
          ["13 Ayak", "350", "370", "1140"],
        ],
      },
    ],
    seo: {
      title: "Çizel | Baytaş Tarım",
      description:
        "Baytaş Tarım çizel: hasattan sonra pulluğa ihtiyaç duymadan toprağı işleyen derin sürüm makinesi. Detaylı bilgi için bize ulaşın.",
    },
  },
  {
    slug: "terminator",
    name: "Terminatör",
    category: "Derin İşleme",
    tagline: "Dipkazan derin toprak işleme makinesi",
    short:
      "65 cm derinliğe kadar derin toprak işleme ve gevşetme için tasarlanan dipkazan makinesi.",
    description:
      "Terminatör Dipkazan 65 cm derinliğine kadar derin toprak işleme ve gevşetme için tasarlanmıştır. Hava, su ve besinlerin hareketine izin verecek yeterli gözeneklere sahip, ideal bir toprak yapısı elde eder. Uzun ömürlü bıçakları kesek oluşumunu önlemek için bozulmuş alt tabakanın altını keser. Merdaneli ve merdanesiz model seçeneği vardır.",
    image: "/machines/terminator-1.jpg",
    gallery: [
      "/machines/terminator-1.jpg",
      "/machines/terminator-2.jpg",
      "/machines/terminator-3.jpg",
    ],
    specTable: {
      columns: [
        "Model",
        "İş Genişliği (cm)",
        "Ayak Sayısı",
        "İş Derinliği (cm)",
        "Ağırlık (kg)",
        "Uzunluk (G*U*Y)(cm)",
      ],
      rows: [
        ["Terminatör Hafif 5 Ayaklı", "260", "5", "45", "1200", "260x260x160"],
        ["Terminatör Hafif 7 Ayaklı", "330", "7", "45", "1500", "270x330x160"],
        ["Terminatör Orta 5 Ayaklı", "260", "5", "55", "1500", "270x260x160"],
        ["Terminatör Orta 7 Ayaklı", "330", "7", "55", "1900", "270x350x160"],
        ["Terminatör Ağır 5 Ayaklı", "260", "5", "65", "2100", "294x260x182"],
        ["Terminatör Ağır 7 Ayaklı", "330", "7", "65", "2650", "300x350x182"],
        ["Terminatör Ağır 9 Ayaklı", "440", "9", "65", "3200", "300x440x182"],
      ],
    },
    seo: {
      title: "Terminatör | Baytaş Tarım",
      description:
        "Baytaş Tarım Terminatör dipkazan: 65 cm derinliğe kadar derin toprak işleme makinesi. Detaylı bilgi için bize ulaşın.",
    },
  },
  {
    slug: "viper",
    name: "Viper",
    category: "Derin İşleme",
    tagline: "Dipkazan derin toprak işleme makinesi",
    short:
      "Pulluk tabanını kıran, toprak nemini önemli ölçüde artıran dipkazan makinesi.",
    description:
      "Viper dipkazan, bitkinin köklerinin yayılmasını ve su birikimini engelleyen, pulluk tabanının kırılmasının yanı sıra toprak nemi birikimini de önemli ölçüde artırır.",
    image: "/machines/viper-1.jpg",
    gallery: [
      "/machines/viper-1.jpg",
      "/machines/viper-2.jpg",
      "/machines/viper-3.jpg",
    ],
    specTable: {
      columns: ["Model", "İş Genişliği (cm)", "Ayak Sayısı", "İş Derinliği (cm)"],
      rows: [
        ["Viper 5 Ayaklı 2,5 mt", "250", "5", "55"],
        ["Viper 7 Ayaklı 3 mt", "300", "7", "55"],
        ["Viper 7 Ayaklı 3,5 mt", "350", "7", "55"],
        ["Viper 9 Ayaklı 4 mt", "400", "9", "55"],
      ],
    },
    seo: {
      title: "Viper | Baytaş Tarım",
      description:
        "Baytaş Tarım Viper dipkazan: pulluk tabanını kıran, toprak nemini artıran derin işleme makinesi. Detaylı bilgi için bize ulaşın.",
    },
  },
  {
    slug: "goble",
    name: "Goble",
    category: "Ağır Diskli",
    tagline: "Katlamasız ağır diskli toprak işleme makinesi",
    short:
      "Ağır diskli yapısıyla anız parçalama ve kesek kırma işlerinde yüksek çalışma hızına sahip güçlü makine.",
    description:
      "Goble, diskli tırmığın ağır hizmet tipidir. Hasat sonrası tarlada kalan bitki artıklarını parçalar, toprağı karıştırır, gübreyi toprağa gömer ve kesekleri kırar. 20 diskten 36 diske kadar seçeneklerle üretilir; yüksek çalışma hızı sayesinde yakıt, zaman ve işçilikten tasarruf sağlar.",
    image: "/machines/goble-yeni-5.jpg",
    gallery: [
      "/machines/goble-yeni-5.jpg",
      "/machines/goble-yeni-1.png",
      "/machines/goble-yeni-2.png",
      "/machines/goble-yeni-3.jpg",
      "/machines/goble-yeni-4.jpg",
    ],
    specTable: {
      columns: ["Disk Sayısı", "İş Genişliği (cm)", "Yol Genişliği (cm)", "Ağırlık (kg)"],
      rows: [
        ["20 Diskli", "220", "250", "1460"],
        ["22 Diskli", "240", "270", "1520"],
        ["24 Diskli", "260", "290", "1580"],
        ["26 Diskli", "280", "310", "1640"],
        ["28 Diskli", "300", "330", "1680"],
        ["30 Diskli", "320", "350", "1850"],
        ["32 Diskli", "340", "370", "1930"],
        ["34 Diskli", "360", "390", "2010"],
        ["36 Diskli", "380", "410", "2100"],
      ],
    },
    seo: {
      title: "Goble | Baytaş Tarım",
      description:
        "Baytaş Tarım katlamasız goble: anız parçalama ve kesek kırma için ağır diskli toprak işleme makinesi. Detaylı bilgi için bize ulaşın.",
    },
  },
  {
    slug: "katlamali-disk-tiller",
    name: "Katlamalı Disk Tiller",
    category: "Ağır Diskli",
    tagline: "Katlamalı disk tiller toprak işleme makinesi",
    short:
      "Hidrolik katlanır kanatlı yapısıyla geniş arazilerde yüksek hızlı toprak işleme yapan disk tiller.",
    description:
      "Yüksek hızlı toprak işleme ve tohum yatağı hazırlama için kullanılır. Hektar başına maliyeti düşürür ve gelecek mahsul için mümkün olan en iyi başlangıcı sağlar. Maksimum verim ve zamandan tasarruf sağlar.",
    image: "/machines/goble-katlamali-1.jpg",
    gallery: [
      "/machines/goble-katlamali-1.jpg",
      "/machines/goble-katlamali-2.jpg",
      "/machines/goble-katlamali-3.jpg",
    ],
    specTable: {
      columns: ["Disk Sayısı", "İş Genişliği (cm)", "Yol Genişliği (cm)", "Ağırlık (kg)"],
      rows: [
        ["32 Diskli", "400", "280", "2650"],
        ["36 Diskli", "450", "280", "2840"],
        ["40 Diskli", "500", "280", "3050"],
        ["44 Diskli", "550", "280", "3210"],
        ["48 Diskli", "600", "280", "3390"],
      ],
    },
    seo: {
      title: "Katlamalı Disk Tiller | Baytaş Tarım",
      description:
        "Baytaş Tarım katlamalı disk tiller: yüksek hızlı toprak işleme ve tohum yatağı hazırlama makinesi. Detaylı bilgi için bize ulaşın.",
    },
  },
  {
    slug: "sap-parcalama",
    name: "Sap Parçalama",
    category: "Anız İşleme",
    tagline: "Sap ve bitki artığı parçalama makinesi",
    short:
      "Hasat sonrası sapları ve bitki artıklarını parçalayarak tarlayı bir sonraki ekime hazırlayan makine.",
    description:
      "Sap parçalama makinesi, hasat sonrası tarlada kalan sap, anız ve bitki artıklarını döner bıçaklarıyla ince parçalar. Parçalanan artıklar toprağa karışarak organik madde kazandırır; toprak işleme ve ekim işlerini kolaylaştırır.",
    image: "/machines/sap-1.jpg",
    gallery: ["/machines/sap-1.jpg", "/machines/sap-2.jpg", "/machines/sap-3.jpg"],
    specGroups: [
      {
        title: "SAP25",
        rows: [
          ["İş Genişliği (cm)", "250"],
          ["Yol Genişliği (cm)", "260"],
          ["Yol Yüksekliği (cm)", "120"],
          ["Ağırlık (kg)", "970"],
          ["Merdane Çapı", "30"],
        ],
      },
      {
        title: "SAP30",
        rows: [
          ["İş Genişliği (cm)", "290"],
          ["Yol Genişliği (cm)", "300"],
          ["Ağırlık (kg)", "1020"],
          ["Merdane Çapı", "30"],
        ],
      },
    ],
    seo: {
      title: "Sap Parçalama | Baytaş Tarım",
      description:
        "Baytaş Tarım sap parçalama makinesi: hasat sonrası sap ve anızları parçalayan güçlü çözüm. Detaylı bilgi için bize ulaşın.",
    },
  },
];

export const GALLERY_IMAGES = [
  { src: "/machines/kaldirac-sahadan-1.webp", alt: "Baytaş Tarım kaldıraç traktörle makine kaldırıyor", caption: "Kaldıraç Sahada" },
  { src: "/machines/kultuvator-1.jpg", alt: "Baytaş Tarım yaylı kültüvatör", caption: "Yaylı Kültüvatör" },
  { src: "/machines/kaldirac-1.png", alt: "Baytaş Tarım kaldıraç makinesi", caption: "Kaldıraç" },
  { src: "/machines/sap-1.jpg", alt: "Baytaş Tarım sap parçalama makinesi", caption: "Sap Parçalama" },
  { src: "/machines/goble-yeni-5.jpg", alt: "Baytaş Tarım katlamasız goble", caption: "Goble" },
  { src: "/machines/goble-katlamali-1.jpg", alt: "Baytaş Tarım katlamalı disk tiller", caption: "Katlamalı Disk Tiller" },
  { src: "/machines/kaldirac-sahadan-2.webp", alt: "Baytaş Tarım kaldıraç sahada traktörle çalışıyor", caption: "Sahadan Kareler" },
  { src: "/machines/sap-2.jpg", alt: "Baytaş Tarım sap parçalama makinesi detay", caption: "İmalat detayı" },
];